import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
function Breadcrumbs({ pageType }) {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="mt-1 mb-1 " style={{ padding: "0px" }}>
      {vPathName === "/StockSetupChangeApprove" ||
      vPathName === "/StockSetupChangeApproveCM" ||
      vPathName === "/StockSetupChangeApprovePM" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Masters{" "}
          </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "1rem" }} />
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Stock Setup Change Approve {pageType}{" "}
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Breadcrumbs;
